export const PHONE_MESSAGE = "Enter a valid phone number, e.g. +91 98765 43210 or +14155552671.";

const INDIAN_MOBILE_RE = /^(?:\+?91|0)?([6-9]\d{9})$/;
const INTERNATIONAL_RE = /^\+\d{8,15}$/;

export function cleanedPhone(raw: string): string {
  return (raw || "").replace(/[\s\-()]/g, "");
}

/** Store-ready E.164. Indian mobiles default to +91; other numbers keep their +. */
export function toE164(raw: string): string | null {
  const cleaned = cleanedPhone(raw);
  if (!cleaned) return null;
  const indian = cleaned.match(INDIAN_MOBILE_RE);
  if (indian) return `+91${indian[1]}`;
  if (INTERNATIONAL_RE.test(cleaned)) return cleaned;
  return null;
}

/**
 * Same rule as the server: an Indian mobile (10 digits starting 6-9, optionally
 * prefixed +91 / 91 / 0) or an international number (+ and 8-15 digits).
 * Returns an error message, or null when the number is acceptable.
 */
export function phoneError(raw: string): string | null {
  const cleaned = cleanedPhone(raw);
  if (!cleaned) return "Enter your mobile number.";
  if (toE164(raw)) return null;
  return PHONE_MESSAGE;
}

/** True when the value is a non-Indian international number (prefix +91 should hide). */
export function isOtherInternational(raw: string): boolean {
  const cleaned = cleanedPhone(raw);
  return INTERNATIONAL_RE.test(cleaned) && !INDIAN_MOBILE_RE.test(cleaned);
}

/** If the user pasted +91 / 91 / 0 plus a 10-digit mobile, keep only the 10 digits. */
export function nationalDigitsIfIndian(raw: string): string | null {
  const cleaned = cleanedPhone(raw);
  const match = cleaned.match(/^(?:\+?91|0)([6-9]\d{9})$/);
  return match ? match[1] : null;
}
